import { NuxtAxiosInstance } from '@nuxtjs/axios'
import processError from '~/helpers/processError'
import { TransactionsRepo } from '~/types'

export default ($axios: NuxtAxiosInstance, $sentry: any): TransactionsRepo => ({
  async fetchTransactions(
    branchId: number,
    params: {
      start_date: string
      end_date: string
      page: number
      per: number
    }
  ) {
    try {
      const res = await $axios.get(
        `therapists/branches/${branchId}/transactions`,
        {
          params,
        }
      )
      if (res.status === 200) {
        return res.data
      }
    } catch (error) {
      processError(error, $sentry)
    }
  },

  async fetchJournalSummary(
    branchId: number,
    params: {
      date: string
      type: 'inspection' | 'clearing'
    }
  ) {
    try {
      const res = await $axios.get(
        `therapists/branches/${branchId}/journal_summary`,
        { params }
      )
      if (res.status === 200) {
        return res.data
      }
    } catch (error) {
      processError(error, $sentry)
    }
  },

  // AIOT-8: issue (and persist) the next 清算番号. Called only when staff
  // actually print a clearing journal — advances the per-branch, per-day
  // counter and returns the issued number.
  async issueJournalClearing(branchId: number, params: { date: string }) {
    try {
      const res = await $axios.post(
        `therapists/branches/${branchId}/journal_clearings`,
        params
      )
      // 201 Created — the endpoint issues (persists) a new clearing number.
      if (res.status === 201) {
        return res.data
      }
    } catch (error) {
      processError(error, $sentry)
    }
  },
})
